'use client';

import { DehydratedState, HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode, useState } from 'react';
export default function ReactQueryProvider({
  children,
  dehydratedState
}: {
  readonly children: ReactNode;
  readonly dehydratedState?: DehydratedState;
}) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000
      }
    }
  }));
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="ReactQueryProvider" data-sentry-source-file="ReactQueryProvider.tsx">
      <HydrationBoundary state={dehydratedState} data-sentry-element="HydrationBoundary" data-sentry-source-file="ReactQueryProvider.tsx">
        <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="ReactQueryProvider.tsx" />
        {children}
      </HydrationBoundary>
    </QueryClientProvider>;
}